import styled from 'styled-components';

const StyledProdsCarousel = styled.div`
  position: relative;
  width: 100%;
  text-align: center;
  margin-bottom: 0;
  h6{
    padding-bottom: ${props => props.theme.components_spacing_desk.xlarge}px;
    padding-top: ${props => props.theme.components_spacing_desk.xlarge}px;
  }
  p{
    padding-bottom: ${props => props.theme.components_spacing_desk.medium}px;
    letter-spacing: 0;
    line-height: 130%;
    margin: 0 auto;
  }
  p span{
    color: ${ props => props.theme.colors.green_secondary};
  }
  h6, p{  
    max-width: 66.66%;
  }
  h6.center{
    margin: 0 auto;
    text-align: center;
  }
  .paragraph--col-wrap{
    padding-top: ${props => props.theme.components_spacing_desk.xxlarge}px ;
    padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px ;
    text-align: left;
    margin-left: 0;
  }
  .mobile-tap{
    display: none;
  }
  .paragraph--col-big.no-padding-bottom h6{
    max-width: 100% !important;
    padding-bottom: 0 !important;
  }
  .swiper-container {
    position: relative;
  }
  .swiper-button-prev,
  .swiper-button-next {
    z-index: 4;
  }
  .carousel-prods--slider .swiper-slide{
    width: 50%;
    margin: 0 auto;
  }
  .carousel-prods--slider .swiper-slide .slide--content {
    position: relative;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  } 
  .carousel-prods--slider .swiper-slide iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    border: none;
    left: 0%;
    top: 0%;
    opacity: 0;
  }
  .carousel-prods--slider .swiper-slide img {
    position: relative;
    display: block;
    width: 60%;
    opacity: 1;
    margin: 0 auto;
    pointer-events: none;
    transition: opacity 0.25s;
  }
  .carousel-prods--slider .swiper-slide .loaded img,
  .carousel-prods--slider .swiper-slide .loaded p{
    opacity: 0;
  }
  .miniloader-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%);
    z-index: 4;
    text-align: center;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
  }
  .miniloader-wrap p {
    margin: 15px auto 0;
    padding: 0;
  }
  .lds-dual-ring {
    display: block;
    width: 40px;
    height: 40px;
  }
  .lds-dual-ring:after {
    content: " ";
    display: block;
    width: 24px;
    height: 24px;
    margin: 8px;
    border-radius: 50%;
    border: 4px solid #000;
    border-color: #000 transparent #000 transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .carousel-prods--slider .swiper-slide .loaded .lds-dual-ring {
    opacity: 0;
  }
  .carousel-prods--slider .swiper-slide .loaded iframe{
    opacity: 1;
  }
  .carousel-prods--slider .swiper-slide .with-iframe:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
 
  .carousel-prods--slider .carousel-prods--img{
    width: 80%;
    margin: 0 auto;
  }
  .carousel-prods--slider .carousel-prods--img img{
    width: 100%;
  }
  .overlay--zoom{
    position: fixed;
    width: 100vw;
    height: 100vh;
    transform: translateX(-100%);
    top: 0; 
    left: 0;
    z-index: 10;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .overlay--zoom iframe {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    border: none;
    
  }
  .overlay--zoom .close--overlay{
    position: absolute;
    right: 64px;
    top: 40px;
    z-index: 11;
    width: 44px;
    height: 44px;
    cursor: pointer;
  }

  .overlay--zoom .close--overlay img {
    display: block;
    width: 100%;
  }
  @media screen and (max-width: 1024px){
    .carousel-prods--img{
      padding-bottom: 94px;
    }
    .mobile-tap{
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 0%);
      display: block;
      pointer-events: none;
      text-align: center;
      padding: 0;
      opacity: 0;
      transition: opacity .25s ease-out;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      width: 128px;
      height: 128px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${ props => props.theme.colors.green_secondary};
    }
    .swiper-slide-active .mobile-tap{
      opacity: 1;
    }
  }
  @media screen and (max-width: 1023px){
    margin-bottom: 0;
    .paragraph--col-wrap{
      padding-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
      padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    }
    h6{
      padding-bottom: ${props => props.theme.components_spacing_tablet.xlarge}px;
      padding-top: ${props => props.theme.components_spacing_tablet.xlarge}px;
    }
    p{
      padding-bottom: ${props => props.theme.components_spacing_tablet.medium}px;
    }
    h6, p{    
      max-width: 83.33%;
    }
  }
  @media screen and (max-width: 767px){
    margin-bottom: 0;

    .carousel-prods--slider .swiper-slide{
      width: 60%;
    
    }
    .carousel-prods--slider .carousel-prods--img, .carousel-prods--slider .carousel-prods--img img{
      width: 90%;
      margin: 0 auto;
    }
    .paragraph--col-wrap{
      padding-top: ${props => props.theme.components_spacing_mobile.xxlarge}px;
      padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    }
    h6{
      padding-bottom: ${props => props.theme.components_spacing_mobile.xlarge}px;
      padding-top: ${props => props.theme.components_spacing_mobile.xlarge}px;
    }
    p{
      padding-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
    }
    h6, p{  
      max-width: 100%;
    }
    .carousel-prods--img{
      padding-bottom: ${ props => props.isShelfzone ? 0 : 70}px;
    }
    .carousel-prods--slider .swiper-slide{
      margin-right: 0;
    }
    .overlay--zoom .close--overlay{
      right: 24px;
    }
    .mobile-tap{
      width: 80px;
      height: 80px;
    }
  }
  .swiper-button-next {
    background-image: url(/arrow-next-carousel.svg);
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
    width: 64px;
    height: 64px;
    right: 64px;
    background-color: #000;
    border-radius: 50%;
    transition: background-color .25s;
    margin-right: 8.33%;
  }
  .swiper-button-disabled{
    display: none;
  }

  .swiper-button-next::after {
    display: none;
  }
  .swiper-button-prev {
    background-image: url(/arrow-prev-carousel.svg);
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
    width: 64px;
    height: 64px;
    left: 64px;
    background-color: #000;
    border-radius: 50%;
    transition: background-color .25s;
    margin-left: 8.33%;
  }
  .swiper-button-prev:hover, .swiper-button-next:hover{
    background-color: ${props => props.theme.colors.green_secondary};
  }
  .swiper-button-prev::after {
    display: none;
  }
  @media screen and (max-width: 1439px){
    .swiper-button-next {
      right: 40px;
      
    }
    .swiper-button-prev {
      left: 40px
    }
  }
  @media screen and (max-width: 1023px){
    .swiper-button-prev {
      margin: 0
    }
    .swiper-button-next {
      margin: 0
    }
  }
  @media screen and (max-width: 767px){
    .swiper-button-next,
    .swiper-button-prev{
      width: 44px;
      height: 44px;
      padding: 6px;
      background-color: transparent;
      transform: translateY(-50%)
    }
    .swiper-button-next:hover,
    .swiper-button-prev:hover{
      background-color: transparent;
    }
    .swiper-button-next{
      right: 24px;
    }
    .swiper-button-prev{
      left: 24px;
    }
    .swiper-button-next::after,
    .swiper-button-prev::after {
      content: '';
      display: block;
      border-radius: 50%;
      background-color: #000;
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: center;
    }
    .swiper-button-next::after{
      background-image: url(/arrow-next-carousel.svg);
    }
    .swiper-button-prev::after{
      background-image: url(/arrow-prev-carousel.svg);
    }
}
`;

export {
  StyledProdsCarousel,
};

